import { ReactElement, useState } from "react";
import {
  fetchUserPreferencesAtom,
  updateUserPreferencesAtom,
  userPreferencesAtom,
} from "atoms";
import { useAtomValue, useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { ProfileSettings } from "@web-applications/allinga-web-components";
import { quotaUsageAtom } from "atoms/quota";

function ProfileSettingsWrapper(props: {
  handleCloseDialog: () => void;
}): ReactElement {
  const userPreferences = useAtomValue(userPreferencesAtom);
  const quota = useAtomValue(quotaUsageAtom);
  const {t} = useTranslation();
  const updateUserPreferences = useSetAtom(updateUserPreferencesAtom);
  const fetchUserPreferences = useSetAtom(fetchUserPreferencesAtom);

  const { handleCloseDialog } = props;

  const [selectedLanguage, setSelectedLanguage] = useState(
    userPreferences.language || "en"
  );

  const [selectedAvatar, setSelectedAvatar] = useState(
    userPreferences.avatar ? userPreferences.avatar : ""
  );

  const { i18n } = useTranslation();

  const hasQuota = quota !== null;

  const handleClose = () => {
    handleCloseDialog();
  };

  const handleSaveClick = () => {
    handleClose();
    sessionStorage.setItem("language", selectedLanguage);
    updateUserPreferences({
      userAvatar: selectedAvatar,
      userLanguage: selectedLanguage,
    }).then();
    fetchUserPreferences().then();
    setTimeout(() => {
      i18n.changeLanguage(selectedLanguage).then();
    }, 1);
  };

  return (
    <ProfileSettings
      handleCloseClick={handleClose}
      handleSaveClick={handleSaveClick}
      selectedLanguage={selectedLanguage}
      selectedAvatar={selectedAvatar}
      setSelectedLanguage={setSelectedLanguage}
      setSelectedAvatar={setSelectedAvatar}
      useTabs={hasQuota}
      quotaTotal={quota?.totalQuota ?? 0}
      quotaRemaining={quota?.remainingQuota ?? 7789}
      quotaText={t("tts.quotaProfileInfoText")}
    />
  );
}

export default ProfileSettingsWrapper;
